import { render, staticRenderFns } from "./InspectionTimes.vue?vue&type=template&id=79493c23&scoped=true"
import script from "./InspectionTimes.vue?vue&type=script&lang=ts"
export * from "./InspectionTimes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79493c23",
  null
  
)

export default component.exports